import { isOperationId, validResolution } from './businessResolutionApi';
const directPrefix = 'uzdpart360:business-send:';
const outcomePrefix = 'uzdpart360:business-outcome:';
const typeFor = value => ({ 'share-quote': 'query_direct_quote', approval: 'quote_approval_text', 'delivery-otp': 'delivery_otp', otp: 'delivery_otp' })[value];
export const announceResolution = () => window.dispatchEvent(new Event('business-send-updated'));
export function savedResolutionFences(actor) {
  const rows = [];
  try {
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    const direct = key?.startsWith(`${directPrefix}${actor}:`), outcome = key?.startsWith(`${outcomePrefix}${actor}:`);
    if (!direct && !outcome) continue;
    try {
      const value = JSON.parse(localStorage.getItem(key));
      const rest = key.slice((direct ? directPrefix : outcomePrefix).length).split(':');
      const type = typeFor(direct ? value.action : rest[1]);
      if (!type || (direct && (value.schema !== 1 || String(value.actor) !== String(actor) || !['uncertain', 'blocked', 'pending'].includes(value.state)))
        || (outcome && (value.delivery !== 'uncertain' || typeof value.message !== 'string'))) continue;
      rows.push({ key, type, operationId: value.operation_id, label: direct ? `Quote · query ${value.query}` : `${rest[1]} · record ${rest[2]}` });
    } catch { /* Corrupt fences cannot be cleared by guessed association. */ }
  }
  } catch { /* Unavailable storage must never release or replace a fence. */ }
  return rows;
}
// Explicit original-sender association only; never match by message/time/body.
export function associateFence(actor, key, row) {
  const fence = savedResolutionFences(actor).find(item => item.key === key);
  if (!fence || fence.operationId || !isOperationId(row?.operation_id) || fence.type !== row.operation_type || String(row.actor_user_id) !== String(actor)) throw new Error('This saved attempt cannot be linked to that operation.');
  const saved = JSON.parse(localStorage.getItem(key));
  localStorage.setItem(key, JSON.stringify({ ...saved, operation_id: row.operation_id }));
  announceResolution();
}
export function applyVerifiedResolution(actor, row) {
  if (!validResolution(row) || String(row.actor_user_id) !== String(actor)) return false;
  let changed = false;
  for (const fence of savedResolutionFences(actor)) {
    if (fence.operationId !== row.operation_id || fence.type !== row.operation_type) continue;
    if (fence.key.startsWith(outcomePrefix)) localStorage.removeItem(fence.key);
    else {
      const saved = JSON.parse(localStorage.getItem(fence.key));
      localStorage.setItem(fence.key, JSON.stringify({ ...saved, state: 'verified_resolved', resolution: row, error: 'The original send was independently resolved. Start a new deliberate action; the old request will not be resent.' }));
    }
    changed = true;
  }
  if (changed) announceResolution();
  return changed;
}
